import { tokens, Icon, Button, Typography } from '@beeline.com/bp-design-system';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDocsSidePanelIntl } from './translations/useDocsSidePanelIntl';
interface Props {}
const DocsDrawerFooter: React.FC<React.PropsWithChildren<Props>> = () => {
  const intl = useDocsSidePanelIntl();
  const handleSupportClick = useCallback(() => {
    window.open('https://beelineco.atlassian.net/servicedesk/customer/portal/19', '_blank')?.focus();
  }, []);
  const handleFeedbackClick = useCallback(() => {
    window
      .open('https://portal.productboard.com/yhdhyanqaf9ddhrvubw4dtmc/tabs/153-ideas-under-consideration', '_blank')
      ?.focus();
  }, []);
  return (
    <StyledBar data-test={'docs-drawer-footer'}>
      <StyledButton dataTest="feedback-button" variant="text" onClick={handleFeedbackClick}>
        <Typography variant="body1" color={tokens.colorOnSurface}>
          {intl.feedbackButton}
        </Typography>
        <Icon name="chat_bubble" />
      </StyledButton>
      <StyledButton dataTest="contact-support-button" variant="text" onClick={handleSupportClick}>
        <Typography variant="body1" color={tokens.colorOnSurface}>
          {intl.contactSupport}
        </Typography>
        <Icon name="open_in_new" />
      </StyledButton>
    </StyledBar>
  );
};
export default DocsDrawerFooter;
const StyledButton = styled(Button)`
  & > span {
    gap: 1rem;
  }
`;
const StyledBar = styled.div`
  display: flex;
  justify-content: flex-end; /* Change to right align */
  align-items: center;
  flex-direction: row;
  background-color: white;
  width: 100%;
  padding: 0.125rem 0.75rem;
  border-top: 1px solid ${tokens.colorSurfaceVariant};
  border-bottom: 1px solid ${tokens.colorSurfaceVariant};
`;
